.root {
  :global {
    .MuiAutocomplete-inputRoot {
      min-height: 3rem;
    }
    .MuiAutocomplete-inputRoot.MuiInputBase-adornedStart {
      padding-left: 0;
    }
  }
}